<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true">
        <div class="contit">基础信息</div>
        <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
          :inputValue="form[c.keyName]" @onChange="onChange" />
      </el-form>

      <el-form ref="form2" :model="form" :label-width="labelWidth" :inline="true">
        <div class="contit">账号信息</div>
        <FormItem v-for="(c, i) in formCtrl2" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
          :inputValue="form[c.keyName]" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "ViceCaptainDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      breadcrumb: [
        { name: "人员管理", path: "/staff/viceCaptain" },
        { name: "副队长管理", path: "/staff/viceCaptain" },
        { name: "添加副队长" },
      ],
      form: {
        sex: '男',
        user_group_id: 11,
      },
    };
  },
  methods: {},
  mounted() {
    this.getOptions();
  },
};
</script>

<style lang="less" scoped>
/deep/ .info_form {
	padding-top: 20px;
	border-radius: 5px;
	background-color: #fff;
	box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
	.el-form {
		/*padding-top: 20px;
		border-radius: 5px;
		box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
		background-color: #fff;*/
		.el-form-item {
			/*border-bottom: 1px solid #f2f6fc;*/
			padding: 0 20px 0 0;
			margin-bottom:25px;
			.el-input {
				width: 300px;
			}
      .el-form-item__content > .el-input {
        width: 300px;
      }
      .el-upload__tip { 
        left: 107px;
        top: 2px;
        width: 150px;
      }
      .el-button--small {
        padding: 13.5px 25.5px;
      }
		}
		// .el-textarea {
		//   width: 200px;
		// }
	}
}

.btns {
  margin: 40px 0 60px 180px;
}
.contit { 
  height: 24px; 
  line-height: 24px; 
  overflow: hidden; 
  margin: 0 auto 25px; 
  padding: 0 21px; 
  font-weight: bold; 
  font-size: 18px; 
  color: #343434;
}
.info_form .el-form:first-child .el-form-item:last-child {
  display: block;
  margin-bottom: 50px;
}
</style>
